const BaseURL = {
    getBaseURL: () => {
        let url = window.location.href;
        if(url.indexOf("localhost") > -1)
            return "http://localhost:5055";
        if(url.indexOf("fb-front-eval2.develability.net") > -1)
            return "https://fb-back-eval2.develability.net";
        if(url.indexOf("fb-front-eval1.develability.net") > -1)
            return "https://fb-back-eval1.develability.net";
        if(url.indexOf("feedback.develability.net") > -1)
            return "https://fb1.develability.net";
        if(url.indexOf("192.168.178.117:5055"))
            return "http://192.168.178.117:5055";
        return "https://feedback.develability.net"
    }
};

export default BaseURL;


// WEBPACK FOOTER //
// ./src/api/BaseURL.js